import initialState from './initialState';
import { types } from './actions';

export default function exportMangementReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADING_STATE: {
      const { loadingState } = action;
      return { ...state, isloading: loadingState };
    }

    case types.TASK_TYPE_CHANGE: {
      const { id, flagVisibilitySetting } = action;
      return { ...state, taskTypeSelected: id, flagVisibilitySetting, flagSetting: flagVisibilitySetting };
    }

    case types.FORM_DETAIL_BUTTON_VISIBLE_STATE: {
      const { formDetailButtonVisibleState } = action;
      return { ...state, formDetailButtonVisibleState };
    }
    case types.DATE_RANGE_CHANGE: {
      const { startDate, endDate } = action;
      return { ...state, dateRange: { startDate, endDate } };
    }

    case types.ROW_DATE_CHANGE: {
      const { rowData } = action;
      return { ...state, rowDataForGlobalandtaskTypeAttibute: rowData };
    }

    case types.ADD_FORM_FIELDS: {
      const { formFields } = action;
      return { ...state, formFields };
    }

    case types.COLUMNDEFS_CHANGE_FOR_FORM_DATA: {
      const { columnDefs } = action;
      return { ...state, columnDefsForFormAttribute: columnDefs };
    }

    case types.ROW_DATA_CHANGE_FOR_FORM_DATA: {
      const { rowData } = action;
      return { ...state, rowDataForFormAttribute: rowData };
    }

    case types.FLAG_SETTINGS: {
      const { flagSetting } = action;

      return { ...state, flagSetting };
    }
    case types.FORM_SCHEMA: {
      const { formSchema } = action;
      return { ...state, formSchema };
    }
    case types.SHOW_TABLE: {
      const { showTable } = action;
      return { ...state, showTable };
    }
    case types.CLEAR_REDUX_STATE: {
      return {
        ...state,
        isloading: false,
        taskTypeSelected: null,
        formDetailButtonVisibleState: false,
        columndefsforGlobalandtaskTypeAttibute: [],
        rowDataForGlobalandtaskTypeAttibute: [],
        rowDataForFormAttribute: [],
        columnDefsForFormAttribute: [],
        formSchema: {},
        showTable: false,
        flagSetting: { ...state.flagSetting },
        flagVisibilitySetting: { customAttribute: false, globalAttribute: false, formData: false },
      };
    }

    case types.SCHEMA_UPDATE_FOR_CUSTOM_ATTRIBUTE: {
      const { columndefsforGlobalandtaskTypeAttibute } = action;
      return { ...state, columndefsforGlobalandtaskTypeAttibute };
    }

    default:
      return state;
  }
}
